import React from 'react';
import BaseTreeViewItem from './index';
import { BaseTreeViewItemProps } from './types';
import { TYPES } from '../../../icon/constants';

const TreeViewItem = ({
  title,
  iconGlyph,
  customIconGlyph = null,
  iconType = TYPES.default,
  selected = false,
  disabled = false,
  onClick = Function.prototype,
  description = null,
  actions = [],
  isEmpty = false,
  draggable = true,
  isDragging = false,
  highlighted = false,
  connectDragSource = Function.prototype,
}) => (
  <BaseTreeViewItem
    iconGlyph={iconGlyph}
    customIconGlyph={customIconGlyph}
    iconType={iconType}
    hoverIconGlyph={draggable ? 'drag-icon' : iconGlyph}
    draggable={draggable}
    title={title}
    selected={selected}
    disabled={disabled}
    onClick={onClick}
    description={description}
    actions={actions}
    isEmpty={isEmpty}
    isDragging={isDragging}
    highlighted={highlighted}
    connectDragSource={connectDragSource}
  />
);

TreeViewItem.propTypes = BaseTreeViewItemProps;

export default TreeViewItem;
